<div class="container" [ngClass]="{ 'container--compact': isCompact, 'is-mobile': isMobile() }">
  <div class="animation-container">
    <div class="animation-wrapper">
      <div class="animation-item">
        <img src="/public/svgs/ai-agent-w.svg" alt="AI agent" />
      </div>
      <div class="animation-shape">
        <img src="/public/svgs/val.svg" alt="AI agent" />
      </div>
      <img src="/public/svgs/ai-agent-w.svg" alt="AI agent" />
    </div>
  </div>
  
  <div class="content-container">
    <div class="greeting-text" *ngIf="!isCompact" [innerHTML]="'app.components.assistantV2.greeting' | translate : { name: userName }">
    </div>
  </div>
</div>
